var _metadata, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 74 73",
    id: "svg6533",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata6537"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6525"
  }, /*#__PURE__*/React.createElement("filter", {
    x: "-23.9%",
    y: "-17.9%",
    width: "147.8%",
    height: "135.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1",
    id: "feOffset6512"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    id: "feGaussianBlur6514"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.145098039   0 0 0 0 0.149019608   0 0 0 0 0.164705882  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    id: "feColorMatrix6516"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "feMerge6522"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1",
    id: "feMergeNode6518"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic",
    id: "feMergeNode6520"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "matrix(3,0,0,3,-72.000003,-73.017011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slozka-list-190415",
    transform: "translate(-302,-544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ovladani",
    transform: "translate(144,344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-copy-6",
    transform: "translate(176,216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "presun",
    transform: "translate(7,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 21.493088,0.02517986 h -4.695277 c -0.27999,0 -0.506912,0.22543837 -0.506912,0.50359712 V 1.9217345 H 12.61816 c -1.399158,0.00157 -2.532979,1.1279789 -2.534563,2.5179856 V 9.9247977 H 5.1705069 V 7.5787433 c 0,-0.2781588 -0.2269225,-0.5035971 -0.5069124,-0.5035971 H 0.50691244 C 0.2269225,7.0751462 0,7.3005845 0,7.5787433 v 5.8385787 c 0,0.278159 0.2269225,0.503598 0.50691244,0.503598 H 4.6635945 c 0.2799899,0 0.5069124,-0.225439 0.5069124,-0.503598 v -2.48533 h 4.9130901 v 5.62455 c 0.0016,1.390007 1.135405,2.516412 2.534563,2.517986 h 3.672739 v 1.392761 c 0,0.278158 0.226922,0.503597 0.506912,0.503597 h 4.695277 C 21.773077,20.970886 22,20.745447 22,20.467289 v -3.792716 c 0,-0.278159 -0.226923,-0.503597 -0.506912,-0.503597 h -4.695277 c -0.27999,0 -0.506912,0.225438 -0.506912,0.503597 v 1.392761 H 12.61816 c -0.839574,-9.84e-4 -1.519748,-0.676709 -1.520738,-1.510792 v -5.62455 h 5.193477 v 1.392761 c 0,0.278158 0.226922,0.503597 0.506912,0.503597 h 4.695277 C 21.773077,12.82835 22,12.602911 22,12.324753 V 8.5320369 C 22,8.2538782 21.773077,8.0284398 21.493088,8.0284398 h -4.695277 c -0.27999,0 -0.506912,0.2254384 -0.506912,0.5035971 V 9.9247977 H 11.097422 V 4.4397201 c 9.9e-4,-0.833886 0.681164,-1.5098077 1.520738,-1.5107914 h 3.672739 v 1.3927608 c 0,0.2781588 0.226922,0.5035971 0.506912,0.5035971 h 4.695277 C 21.773077,4.8252866 22,4.5998483 22,4.3216895 V 0.52877698 C 22,0.25061823 21.773077,0.02517986 21.493088,0.02517986 Z M 4.156682,12.913725 H 1.0138249 V 8.0823404 H 4.156682 Z m 13.148042,4.264445 h 3.681451 v 2.785521 h -3.681451 z m 0,-8.142536 h 3.681451 v 2.785522 H 17.304724 Z M 20.986175,3.8178957 H 17.304724 V 1.0323741 h 3.681451 z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIcon);
export default __webpack_public_path__ + "static/media/MoveIcon.ed0008f9ffbf6b80c27d8975d83ce1ab.svg";
export { ForwardRef as ReactComponent };